module.exports = __webpack_public_path__ + "assets/images/premium-features/shift-feedback-banner-new-154e38.png";